import React, { MutableRefObject, useCallback, useMemo, useRef, useState } from "react";
import { Button, Card, CardContent, Icon, Label } from "semantic-ui-react";
import ContentEditorPost from "./ContentEditorPost";
import "suneditor/dist/css/suneditor.min.css";
import { POST } from "react-lib/apps/segment/sequence/SegmentTarget";

type CardSegementPostProps = {
  setProp: any;
  runSequence: any;
  SegmentTargetSequence: any;
  setModalParam: any;
  optionsOrgans: any[];
};

const CardSegmentPost = (props: CardSegementPostProps) => {
  return (
    <div style={{ height: "100%", width: "100%", overflow: "scrollY" }}>

      <div style={{ display: "flex", justifyContent: "flex-end", padding: "3px 0px" }}>
        <Button
          size="tiny"
          color="pink"
          icon
          labelPosition="left"
          onClick={() => {
            props.runSequence({
              sequence: "SegmentTarget",
              action: "AddContent",
              type: POST
            });
          }}
        >
          <Icon name="plus" />
          สร้างโพสต์
        </Button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "3px"}}>
        {props.SegmentTargetSequence.posts?.map((item, idx) => (

            <ContentEditorPost
              key={item?.id}
              id={item?.id}
              version={item?.version}
              errorField={null}
              content={item.content || ""}
              organTags={item.organ_tags || []}
              isEdit={item.isEdit}
              publishedAt={item.published_at}
              publishedVersion={item.published_version}
              updatedAt={item.updated_at}
              updatedBy={item.updated_by}
              idxPublishLoading={props.SegmentTargetSequence?.idxPublishLoading}
              idxUnpublishLoading={props.SegmentTargetSequence?.idxUnpublishLoading}
              idxSaveLoading={props.SegmentTargetSequence?.idxSaveLoading}
              setModalParam={props.setModalParam}
              publishJson={props.SegmentTargetSequence?.publishJson}
              optionsOrgans={props.optionsOrgans}
              runSequence={props.runSequence}
            />

        ))}
      </div>
    </div>
  );
};

export default CardSegmentPost;
